const { getB2bApiUrls } = require('../b2b-api')

const platform = {
  B2B_API_ENDPOINT: 'https://api-pro.twistoapp.com',
  AUTH: {
    ISSUER: 'https://id-pro.twistoapp.com/realms/company',
    CLIENT_ID: 'webapp',
    AUDIENCE: 'ace-company',
  },
}

exports.b2bProduction = {
  ...platform,
  ONBOARDING: {
    API_ENDPOINT: getB2bApiUrls(platform).ONBOARDING_API_ENDPOINT,
    FLOW_ID: 'b4691de4-4168-45fa-b3eb-3dcd2dfaac41',
  },
}
